/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Export_ExcelInputs */

const en_reports_export_excel = /** @type {(inputs: Reports_Export_ExcelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excel (.xlsx)`)
};

const pt_br2_reports_export_excel = /** @type {(inputs: Reports_Export_ExcelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excel (.xlsx)`)
};

/**
* | output |
* | --- |
* | "Excel (.xlsx)" |
*
* @param {Reports_Export_ExcelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const reports_export_excel = /** @type {((inputs?: Reports_Export_ExcelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Export_ExcelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_export_excel(inputs)
	return pt_br2_reports_export_excel(inputs)
});